import { render, staticRenderFns } from "./userRoleManage.vue?vue&type=template&id=29872494&scoped=true&"
import script from "./userRoleManage.vue?vue&type=script&lang=js&"
export * from "./userRoleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29872494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29872494')) {
      api.createRecord('29872494', component.options)
    } else {
      api.reload('29872494', component.options)
    }
    module.hot.accept("./userRoleManage.vue?vue&type=template&id=29872494&scoped=true&", function () {
      api.rerender('29872494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/user/userRoleManage.vue"
export default component.exports